import { Button, Image, message } from 'antd';
import React from 'react';
import Item from './Item';
import {Link, useHistory} from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from '../../../util/Api';

const General = ({passport}) => {
  const history = useHistory();
  const {authUser} = useSelector(({auth}) => auth);
  
  const deletePassportHandler = () => {
    const url = `/passport/remove?id=${passport.id}`;
    axios.post(url, {}).then(resp => {
      message.success('Menonaktifkan personel telah berhasil dilakukan');
      window.location.reload();
      // history.replace(`/passport/detail?id=${passport.id}`);
    }).catch(err => {
      message.error('Gagal menonaktifkan personel');
    });
  }

  const activatePassportHandler = () => {
    const url = `/passport/activate?id=${passport.id}`;
    axios.post(url, {}).then(resp => {
      message.success('Personel telah berhasil diaktifkan');
      window.location.reload();
      // history.replace(`/passport/detail?id=${passport.id}`);
    }).catch(err => {
      message.error('Gagal mengaktifkan personel');
    });
  }

  return (
    <>
      {authUser.vendor ? null : (
        <>
          <Link to={`/passport/update?id=${passport.id}`}>
            <Button type="primary" ghost className="gx-mb-3">Update Data</Button>
          </Link>
          {passport.is_deleted ? <Button onClick={activatePassportHandler} className="gx-mb-3 gx-ml-2" type="primary" danger>Aktifkan Personel</Button> : <Button type="primary" danger className="gx-mb-3 gx-ml-2" onClick={deletePassportHandler}>Nonaktifkan Personel</Button>}
          <hr />
        </>
      )}

      {passport.is_deleted ? <div className="gx-mb-4 gx-text-center gx-text-danger">Personel telah dinonaktifkan</div> : null}

      <Item label={`Nomor Personel`} value={passport.number} />
      <Item label={`Nama Lengkap`} value={passport.name} />
      <Item label={`Nomor Identitas`} value={passport.identity.number} />
      <Item label={`Jenis Identitas`} value={passport.identity.type.label} />
      {passport.identity.file ? <Item label={`File Identitas`} value={(
        <>
          {passport.identity.is_image ? <Image height={100} width={100} src={passport.identity.file_url} /> : <a href={passport.identity.file_url}>Download File Identitas</a>}
        </>
      )} /> : <Item label="File Identitas" value="Belum diunggah" />}
      <Item label={`Departemen`} value={passport.department.label} />
      <Item label={`Level Jabatan`} value={passport.position.label} />
      <Item label={`Vendor`} value={passport.vendor.name} />
      <Item label={`Pendidikan Terakhir`} value={passport.education.label} />
      <Item label={`Jenis Kelamin`} value={passport.gender} />
      <Item label={`Kebangsaan`} value={(<span style={{ textTransform: "uppercase" }}>{passport.nationality}</span>)} />
      <Item label={`Email`} value={passport.email} />
      <Item label={`HP/WA`} value={passport.phone} />
      <Item label={`Kontak Darurat`} value={passport.emergency_contact} />
      <Item label={`Golongan Darah`} value={passport.blood_type} />
    </>
  );
}

export default General;

